import { render } from "./UserEvents.vue?vue&type=template&id=7b41e03b"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"

import "./UserEvents.vue?vue&type=style&index=0&id=7b41e03b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__